import {useState, useEffect} from 'react';

// function getIsMobile() {
//     return window.innerWidth <= 768;
// } 

export default function useIsMobile(threshold = 768) {
    const [isMobile, setIsMobile] = useState(() => window.innerWidth <= threshold);

    useEffect(() => {
        function onResize() {
            setIsMobile(window.innerWidth <= threshold);
        }
        window.addEventListener("resize", onResize);
        return () => {
            window.removeEventListener("resize", onResize);
        }
    }, [threshold]);

    return isMobile;
}